import { EntityDetailsDisplayInfoFieldPersonOnBoard, getValitationRules } from "../EntityDetailsDisplayInfo";
import { Control, FieldValues, useController } from "react-hook-form";
import Flight from "../../../models/flight";
import InputBox from "../../InputBox/InputBox";
import { useEffect } from "react";
import { getPassengerStops } from "../../../models/flightLegs";

interface EntityPobComponentProps<Entity extends FieldValues> {
    displayInfoInput: EntityDetailsDisplayInfoFieldPersonOnBoard<Entity>;
    control: Control<Entity, any>
    edittedFlight: Flight;
}

function EntityPobComponent<Entity extends FieldValues>({ control, displayInfoInput, edittedFlight }: EntityPobComponentProps<Entity>) {
  const {
    field,
    fieldState,
    formState: { isSubmitting, isValid },
  } = useController({
    name: displayInfoInput.key,
    control,
    rules: getValitationRules(displayInfoInput),
  });

  const {value: fieldValue, onChange: fieldOnChange} = field
  const disabled = (isValid && isSubmitting) || (displayInfoInput.disabled ?? false);

  useEffect(() => {
    //POB at departure: the crew plus the passengers boarding there (a passengers span that starts
    //at a stop, or a passenger's own boarding stop, means they're not aboard yet)
    const crewCount = [edittedFlight.pic, edittedFlight.sic, edittedFlight.deadheadCrew, edittedFlight.studentPilot].filter( (e) => e).length
    const paxAtDeparture = (edittedFlight.passengers ?? []).filter((p) => getPassengerStops(edittedFlight, p.id).fromIndex === 0).length
    const newCount: number = crewCount + paxAtDeparture
    if (fieldValue !== newCount){
        fieldOnChange(newCount)
    }
  }, [edittedFlight.pic, edittedFlight.sic, edittedFlight.deadheadCrew, edittedFlight.studentPilot, edittedFlight.passengers, edittedFlight.passengersLeg, edittedFlight.passengersLeg?.route, edittedFlight.passengerLegs, edittedFlight, fieldValue, fieldOnChange])

  return (
    <InputBox
      value={field.value}
      onChange={(s: any) => {}}
      field={field}
      fieldState={fieldState}
      isDisabled={disabled}
      name={displayInfoInput.name}
      type={"number"}
    />
  );
}

export default EntityPobComponent